<template>
  <section class="va-home-section va-favorites">
    <vetalfa-home-section-header
      title="Seus favoritos"
      action-text="Ver todos"
      @action="$emit('view-all')"
    ></vetalfa-home-section-header>
    <!-- Mobile: estante horizontal com o mesmo card de Recomendados. -->
    <div v-if="mobile" class="va-shelf">
      <div class="va-shelf-track">
        <div
          v-for="(item, index) in visibleItems"
          :key="`home-favorite-${item.id}-${index}`"
          class="va-rec-card va-shelf-card"
          role="button"
          tabindex="0"
          :aria-label="`${typeLabel(item)}: ${displayName(item)}`"
          @click="$emit('select', { item, position: index })"
          @keydown.enter.prevent="$emit('select', { item, position: index })"
          @keydown.space.prevent="$emit('select', { item, position: index })"
        >
          <span class="va-rec-type">{{ typeLabel(item) }}</span>
          <span class="va-rec-name">{{ displayName(item) }}</span>
        </div>
      </div>
    </div>

    <!-- Desktop: grade de blocos, tres colunas, no padrao de atalhos das homes
         de streaming e leitura. -->
    <div v-else class="va-home-grid va-fav-grid">
      <div
        v-for="(item, index) in visibleItems"
        :key="`home-favorite-${item.id}-${index}`"
        class="va-fav-tile"
        role="button"
        tabindex="0"
        :aria-label="`${typeLabel(item)}: ${displayName(item)}`"
        @click="$emit('select', { item, position: index })"
        @keydown.enter.prevent="$emit('select', { item, position: index })"
        @keydown.space.prevent="$emit('select', { item, position: index })"
      >
        <span class="va-fav-tile-type">{{ typeLabel(item) }}</span>
        <span class="va-fav-tile-name">{{ displayName(item) }}</span>
      </div>
    </div>
  </section>
</template>

<style>
.va-favorites {
  gap: 12px;
}

.va-fav-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}


.va-fav-tile {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  min-height: 72px;
  padding: 12px;
  border-radius: 12px;
  background: #f5f6fa;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.va-fav-tile:hover {
  background: #eef0f5;
}

.va-fav-tile-type {
  font-size: 11px;
  line-height: 14px;
  color: #6b7a90;
}

.va-fav-tile-name {
  font-size: 14px;
  line-height: 18px;
  color: #193153;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>

<script>
import HomeSectionHeader from "@/components/home/HomeSectionHeader.vue";
import contentRoutes from "@/constants/content.routes.js";

export default {
  name: "HomeFavorites",
  components: {
    "vetalfa-home-section-header": HomeSectionHeader,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** Ate seis blocos: duas linhas de tres no desktop, uma estante no mobile. */
    visibleItems() {
      return this.items.slice(0, 6);
    },
  },
  methods: {
    typeLabel(item) {
      return contentRoutes.getContentTypeLabel(item);
    },
    displayName(item) {
      return contentRoutes.getDisplayName(item);
    },
  },
};
</script>
